import { styled } from '@mui/material';

export const CustomIcon = styled('span')(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: 4,
  border: '1px solid var(--Gray-300, #D0D5DD)',
  backgroundColor: 'transparent',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',

  '.Mui-focusVisible &': {
    outline: '2px solid rgba(21,112,239,0.4)',
    outlineOffset: 2,
  },
  'input:disabled ~ &': {
    opacity: 0.5,
  },
}));

export const CustomCheckedIcon = styled(CustomIcon)({
  borderColor: '#1570EF',
  '&::before': {
    content: '""',
    width: 20,
    height: 20,
    display: 'block',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%231570EF' /%3E%3C/svg%3E\")",
  },
});
